<template>
    <!-- 导航 -->
    <NavBar
        class="nav"
        :bgcolor="$newYearStyle ? '#DAADA4' : '#a4beda'"
    >
        <template v-slot:title>
            <span class="nav-title">碎片合成</span>
        </template>
    </NavBar>

    <main>
        <div class="cont-box" v-for="product in products" :key="product.id">
            <div class="flex-box">
                <div>
                    <img :src="product.cover" />
                </div>
                <section class="message">
                    <span class="title">{{ product.name }}</span>
                    <section v-if="! product.type">
                        <span class="tag-r1">限量</span>
                        <span class="tag-r2">{{ product.total }} 份</span>
                    </section>
                    <p class="times-T">{{ dateFormat('YYYY-mm-dd', product.release_time) }} <span v-if="Date.parse(new Date(product.offline_time))">至 {{ dateFormat('YYYY-mm-dd', product.offline_time) }}</span></p>
                </section>
            </div>
            <div class="syn-itme-list">
                <div class="list-item">
                    <div class="item" :class="{que: exists.indexOf(need.id) == -1, consume: need.isCatalyst}" v-for="need in product.needs" :key="need.id">
                        <img :src="need.cover" />
                        <img class="icon-jia" src="@/assets/images/jia.png" />
                    </div>
                </div>
                <div class="list-btn list-btn-hui" v-if="isLack(product.needs)">
                    <span> 去合成<van-icon size="12" name="arrow" /> </span>
                </div>
                <router-link :to="'/compose/' + product.id + '?type=' + product.type" class="list-btn" v-else>
                    <span> 去合成<van-icon size="12" name="arrow" /> </span>
                </router-link>
            </div>
        </div>

        <van-empty v-if="! loading && ! products.length"
            :image="require('@/assets/images/kong.png')"
            description="暂无可合成藏品"
        />
        <!-- <footer>
            <img class="xhl-wang" src="@/assets/images/xhl.png" alt="" />
            <span>技术支持</span>
        </footer> -->
    </main>
</template>

<script src="./Page.js"></script>

<style src="./Page.scss" lang="scss" scoped></style>